import { Component, inject } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { CONFIRM_TRANSLATE_CONTEXT } from "@shared/heplers/const-data";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-proceed-confirm-modal",
    templateUrl: "./proceed-confirm-modal.component.html",
    styleUrls: ["./proceed-confirm-modal.component.scss"],
    imports: [TranslateModule]
})
export class ProceedConfirmModalComponent {
    modalRef = inject(BsModalRef);

    onConfirm: Function;
    isConfirm = false;
    isForExtraCartItemsTerms = false;
    readonly context = CONFIRM_TRANSLATE_CONTEXT;
    resourceId: number;

    confirm() {
        this.isConfirm = true;
        this.onConfirm();
        this.modalRef.hide();
    }

    decline() {
        this.isConfirm = false;
        this.modalRef.hide();
    }
}
